import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import { useTranslation } from 'react-i18next'
import React from 'react'

import ContainedButton from 'shared/components/Buttons/ContainedButton'
import OutlinedButton from 'shared/components/Buttons/OutlinedButton'

interface Props {
   onDelete: () => void
   onClose: () => void
   customerName: string
   isDeleting: boolean
}

export default function DeleteModal({ onDelete, isDeleting, onClose, customerName }: Props) {
   const { t } = useTranslation(['TRANSLATION', 'CUSTOMERS'])

   return (
      <>
         <DialogTitle>{t('CUSTOMERS:modal.delete.title', { customerName })}</DialogTitle>
         <DialogActions>
            <OutlinedButton variant="outlined" disabled={isDeleting} isDelete onClick={onClose}>
               {t('TRANSLATION:cancel')}
            </OutlinedButton>
            <ContainedButton variant="contained" disabled={isDeleting} isDelete onClick={onDelete}>
               {t('TRANSLATION:delete')}
            </ContainedButton>
         </DialogActions>
      </>
   )
}
